import { call } from '../@';

export type ProgressStatus = 'done' | 'pending' | 'notStarted';

export default async function approveCompany(id: string) {
	return await call('company-approve', { id });
}
